// extracted by mini-css-extract-plugin
export default {"bottomRightPosition":"BottomRightCornerActions_bottomRightPosition__JgGEO"};